import styled from "styled-components";
import theme from "../../../styles/theme";

export const InputLbl = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .lbl {
    font-size: ${theme.fontSize.mm};
    margin-top: 1vh;
    margin-right: auto;
    color: ${theme.colors.brown.primary};
  }
`;
export const Input = styled.textarea`
  background-color: white !important;
  padding: 10px;
  margin-top: 1vh;
  border-radius: 5px;
  color: black;
  font-size: ${theme.fontSize.md};
  width: 100%;
  transition: background-color 0.3s ease;
  resize: none;
  &:-webkit-autofill {
    background-color: white !important;
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    -webkit-text-fill-color: black !important;
  }

  &:-moz-autofill {
    background-color: white !important;
    box-shadow: 0 0 0px 1000px white inset !important;
    -moz-text-fill-color: black !important;
  }
  &[readonly] {
    background-color: #f5f5f5;
    color: #9e9e9e;
    border: 1px solid #d3d3d3;
    cursor: not-allowed;
  }
`;
export const ErrorLbl = styled.span`
  /* margin-right: auto; */
  color: red;
  margin-top: 5px;
  font-family: sans-serif;
  font-weight: bolder;
  font-size: ${theme.fontSize.sm};
  margin-right: auto;
`;
